import ViewUserDetailsContainer from "./ViewUserDetailsContainer";

export default ViewUserDetailsContainer;
